const aiChatMessageStyles = {
  message: {
    padding: ".5rem",
    maxWidth: "70%",
  },
  humanMessage: {
    backgroundColor: "primary.main",
    color: "primary.contrastText",
    alignSelf: "flex-end",
  },
  assistantMessage: {
    alignSelf: "flex-start",
  },
};

export default aiChatMessageStyles;
